import { useActiveStoreCatalog } from '../../store/selectors/menu';
import { React } from "react";
import { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Grid, Typography, Button, Divider } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import useIsDesktop from "../../hooks/useIsDesktop";
import user from "../../assets/images/user.png";
import { BUTTON_COLOR, TEXT_COLOR } from "../../utils/constant";
import Navbar from "../../components/Navbar";
import ItemModifier from "../../components/Modifier";
import PreviousOrder from "./PreviousOrder";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  addToCart,
  removeItem,
  addQuantity,
  subtractQuantity,
  clearCart,
} from "../../store/actions/cartActions";
import {
  clear_customer,
  clear_order_details,
  clear_order_type,
  clear_last_order,
  clear_order_request,
  set_last_order,
  set_filters,
  preload_menu_data,
} from "../../store/actions/action";
import ExtraItems from "../../components/ExtraItems";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SearchIcon from "@mui/icons-material/Search";

import { Dialog, DialogContent, TextField } from "@material-ui/core";
import { get_customer_list } from "../../utils/customer_helper";

// Desktop frame helper – pins fixed elements to the 814px centered frame
const FRAME_WIDTH = 814;
const getFrameFixed = () => {
  if (window.innerWidth >= 768) {
    const offset = `calc(50% - ${FRAME_WIDTH / 2}px)`;
    return { left: offset, right: offset, width: `${FRAME_WIDTH}px` };
  }
  return { left: "0px", right: "0px", width: "100%" };
};

const Customer = (props) => {
  const { reducer, cartProps } = props;
  const { customer, last_order } = reducer;
  const storeInfo = props.sessionReducer?.store_details;
  const storeInfoConfig = props.sessionReducer?.store_config;
  const navigate = useNavigate();
  const { items: catalogItems, item_variants: catalogItemVariants } = useActiveStoreCatalog();

  const [searchQuery, setSearchQuery] = useState("");

 
  let storeCurrency = storeInfo?.store_currency;
  let currency = "$";
  switch (storeCurrency) {
    case "INR":
      currency = "₹";
      break;
    case "USD":
    case "CAD":
      currency = "$";
      break;
    case "OMR":
      currency = "OMR ";
      break;
    case "AED":
      currency = "AED ";
      break;
    default:
      currency = "$";
  }

  const [isReload, setIsReload] = useState(true);
  const [allitem, setAllitem] = useState([]);
  const [itemVerriantList, setItemVerriantList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modifierPopup, setModifierPopup] = useState(false);

  const onloadData = async () => {
    let StoreItems = catalogItems || [];
    if (StoreItems.length === 0) {
      await props.preload_menu_data();
      StoreItems = catalogItems || [];
    }
    let filered = StoreItems?.filter((e) => e?.tag[0] === "Best");
    setAllitem(filered);
    setIsReload(!StoreItems?.length);
  };


  let primaryColor =  storeInfoConfig?.general_config?.primary_color;
  let secondaryColor =  storeInfoConfig?.general_config?.secondary_color;

  // const [isPopupOpen, setIsPopupOpen] = useState(false);

  // const openPopup = () => {
  //   setIsPopupOpen(true);
  // };

  // const closePopup = () => {
  //   setIsPopupOpen(false);
  // };

  const fetchData = async () => {
    const isCustomerLoggedIn = customer?.cust_mobile && customer?.guest !== "Guest";
    if (!isCustomerLoggedIn) return;

    try {
      const resp = await get_customer_list({
        cust_mobile: customer?.cust_mobile,
      });
      let customer_resp = {};
      if (resp?.customer_details?.length) {
        customer_resp = resp;
        props?.set_last_order({ ...customer_resp });
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  useEffect(() => {
    onloadData();
    if (!last_order?.order_details || last_order.order_details.length === 0) {
      fetchData();
    }
  }, []);

  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return (
      <div style={{ minHeight: "100vh", backgroundColor: "#FAFAFA" }}>
        <PreviousOrder
          {...props}
          {...{ itemVerriantList: catalogItemVariants || itemVerriantList, currency, storeInfo, customer, searchQuery }}
        />
      </div>
    );
  }

  return (
    <>
      <Grid style={{ minHeight: "100vh", backgroundColor: "#F8F9FA", paddingBottom: "100px", boxSizing: "border-box" }}>
        {/* Sticky Header with Back Arrow and Search Input */}
        <Grid
          container
          style={{
            padding: "16px 20px",
            backgroundColor: "white",
            boxShadow: "rgba(0, 0, 0, 0.05) 0px 2px 10px",
            position: "sticky",
            top: 0,
            zIndex: 10,
          }}
        >
          <Grid item xs={12} style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
            <ArrowBackIosNewIcon
              onClick={() => navigate("/menu")}
              style={{
                cursor: "pointer",
                color: primaryColor || BUTTON_COLOR,
                fontSize: "20px",
                marginRight: "16px",
              }}
            />
            <Typography variant="h5" style={{ fontWeight: "700", fontFamily: "Satoshi", color: "#2D3748" }}>
              Your Orders
            </Typography>
          </Grid>
          
          {/* Search Box */}
          <Grid item xs={12}>
            <div style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #E2E8F0",
              borderRadius: "10px",
              padding: "10px 16px",
              backgroundColor: "white",
              boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.05)",
            }}>
              <SearchIcon style={{ color: primaryColor || BUTTON_COLOR, marginRight: "10px", fontSize: "20px" }} />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search Item Name, Store Name"
                style={{
                  border: "none",
                  outline: "none",
                  width: "100%",
                  fontSize: "15px",
                  fontFamily: "Satoshi",
                  color: "#2D3748",
                }}
              />
            </div>
          </Grid>
        </Grid>

        <ItemModifier
          style={{ minWidth: "20rem" }}
          {...props}
          {...{
            modifierPopup,
            setModifierPopup,
            selectedItem,
            setSelectedItem,
            allitem,
            itemVerriantList,
            currency,
          }}
        />
        <PreviousOrder
          {...props}
          {...{ itemVerriantList: catalogItemVariants || itemVerriantList, currency, storeInfo, customer, searchQuery }}
        />
        <Grid
          style={{
            display: "flex",
            position: "fixed",
            ...getFrameFixed(),
            bottom: "0px",
            justifyContent: "center",
            padding: "1rem 1.8rem",
            margin: "0px 0px",
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              props.clearCart();
              props.clear_customer();
              props.clear_order_details();
              props.clear_order_type();
              props.clear_last_order();
              props.clear_order_request();
              navigate("/", { state: { skipAutoRedirect: true } });
            }}
            style={{
              fontSize: "1rem",
              borderRadius: "1rem",
              // padding: '0.5rem 1rem',
              minWidth: "100%",
              padding: "1rem",

              color: "white"  || TEXT_COLOR,
              backgroundColor: primaryColor|| BUTTON_COLOR,
            }}
          >
            Log Out
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    reducer: state.customerReducer,
    cartProps: state.cartReducer,
    sessionReducer: state.sessionReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (items, quantity) => {
      dispatch(addToCart(items, quantity));
    },
    removeItem: (item) => {
      dispatch(removeItem(item));
    },
    addQuantity: (item) => {
      dispatch(addQuantity(item));
    },
    subtractQuantity: (item) => {
      dispatch(subtractQuantity(item));
    },
    clearCart: () => {
      dispatch(clearCart());
    },
    clear_customer: () => {
      dispatch(clear_customer());
    },
    clear_order_details: () => {
      dispatch(clear_order_details());
    },
    clear_order_type: () => {
      dispatch(clear_order_type());
    },
    clear_last_order: () => {
      dispatch(clear_last_order());
    },
    clear_order_request: () => {
      dispatch(clear_order_request());
    },
    set_last_order: (obj) => {
      dispatch(set_last_order(obj));
    },
    set_filters: (obj) => {
      dispatch(set_filters(obj));
    },
    preload_menu_data: () => {
      return dispatch(preload_menu_data());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Customer);
